import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataProtectionDetailComponent } from './data-protection-detail/data-protection-detail.component';
import { DataProtectionListComponent } from './data-protection-list/data-protection-list.component';

const routes: Routes = [
    {
        path: 'dataProtection',
        children: [
            { path: '', component: DataProtectionListComponent }
        ]
    },
    {
        path: 'dataProtection/:id',
        children: [
            { path: '', component: DataProtectionDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DataProtectionRoutingModule { }